const defaultProperties = {
  align: 'flex-start',
  backgroundColor: '#606F99',
  color: '#FFFFFF',
  radius: 4,
  iconPrefix: {
    show: false,
    src: '',
  },
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/06/03/image-6a1f8e0dd4865b45728c40d9.png',
  },
  text: 'Shop Now',
  link: '#',
  show: true,
  subBtn: {
    show: false,
    text: '30-Day Money-Back Guararantee',
  },
  policy: {
    show: true,
    colPerView: 2,
    alignContent: 'center',
    items: [
      {
        icon: 'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/05/25/image-6a14102101d90d908a5f9ce8.png',
        text: '45-Day Money- Back Guarantee',
      },
    ],
  },
};

export default (properties = {}) => {
  const finalProperties = {
    ...defaultProperties,
    ...properties,
  };
  return `
  <div data-attribute="wrap-button" data-align="${finalProperties.align}" data-show="${
    finalProperties.show ? 'true' : 'false'
  }" class="wrap-button" style="--align: ${finalProperties.align};">
    <a data-show="${finalProperties.show ? 'true' : 'false'}" href="${
    finalProperties.link
  }" data-attribute="btn-link" data-background="${finalProperties.backgroundColor}" data-color="${
    finalProperties.color
  }" data-radius="${finalProperties.radius}"
        class="btn-link" style="background-color: ${finalProperties.backgroundColor}; color: ${
    finalProperties.color
  }; border-radius: ${finalProperties.radius}px; --radius: ${finalProperties.radius}px; --bg-btn: ${
    finalProperties.backgroundColor
  }; --color-btn: ${finalProperties.color};">
    <span data-show="${
      finalProperties.iconPrefix.show ? 'true' : 'false'
    }" data-attribute="icon-prefix" class="icon-prefix" style="display: none;">
    <img data-attribute="icon-prefix-image"
        src="${finalProperties.iconPrefix.src}" alt="">
    </span>
    <span data-attribute="text-btn" class="text-btn">${finalProperties.text}</span>
    <span data-show="${
      finalProperties.iconSuffix.show ? 'true' : 'false'
    }" data-attribute="icon-suffix" class="icon-suffix">
    <img data-attribute="icon-suffix-image"
        src="${finalProperties.iconSuffix.src}"
        alt="">
    </span>
    </a>
    <div data-show="${
      finalProperties.subBtn.show ? 'true' : 'false'
    }" data-attribute="sub-btn" class="sub-btn" style="display: ${finalProperties.subBtn.show ? 'block' : 'none'};">
        ${finalProperties.subBtn.text}
    </div>
  </div>
  <div data-show="${finalProperties.policy.show ? 'true' : 'false'}" data-col-perview="${
    finalProperties.policy.colPerView
  }" data-align-content="${
    finalProperties.policy.alignContent
  }" data-attribute="sub-grid-btn" class="grid-policy" style="display: ${
    finalProperties.policy.show ? 'flex' : 'none'
  }; --col-perview: ${finalProperties.policy.colPerView}; --align-content: ${finalProperties.policy.alignContent};">
    ${finalProperties.policy.items
      .map(
        item => `
        <div data-attribute="item-policy" class="wrap-policy-item">
          <div class="icon">
              <img data-attribute="icon-image" src="${item.icon || ''}" alt="">
          </div>
          <div data-attribute="policy-text" class="text">${item.text || ''}</div>
        </div>
    `,
      )
      .join('')}
  </div>
  `;
};
